/**
 * Plateforme multi événement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.compteARebours.ts
 *
 * Compte à rebours avant l'événement (2026-10-07, demande de Mika : « je
 * veux pouvoir fermer "compte à rebours", et le jour J, il ne doit pas être
 * présent »). Le jour J, aucun « J-0 » : la pastille de l'en-tête dit
 * « Jour J » et les écrans d'attente disent « aujourd'hui ». Fusionné dans
 * fr.ts. Mikael - chef de projet - 2026-10-07
 */
export const messagesCompteAReboursFr: Record<string, string> = {
  'compteARebours.fermer': 'Fermer le compte à rebours',
  'compteARebours.pastilleJourJ': 'Jour J',
  'compteARebours.scannerTitre': 'Le scanner ouvre aujourd’hui, dès l’ouverture.',
  'compteARebours.webradioCorps':
    'Le direct ouvre aujourd’hui à partir de 9 h. Découvrez le programme webradio ci-dessous.',
  'compteARebours.webtvTitre': 'WebTV, direct aujourd’hui, dès l’ouverture.',
};
